import React, { useState } from 'react';
import { Link } from "react-router-dom"
import { FiUserPlus, FiLogIn } from "react-icons/fi"
import { Navigate, useNavigate } from "react-router-dom";

import { auth } from "../functions/firebaseFunctions"

export default function LoginForm(props) {
    const [Err, setErr] = useState(null);
    const navigateTo = useNavigate();
    const logIn = async event => {
        event.preventDefault()
        const { email, password } = event.target
        if (email.value && password.value) {
            auth.signInWithEmailAndPassword(email.value, password.value).then(() => {
                navigateTo('/Profile/dashboard');
            }).catch(function (e) {
                setErr(e);
            });
        } else {
            if (!email.value) {
                setErr({ message: 'Fill in the E-mail field', code: 'EmptyEmail' });
            }
            if (!password.value) {
                setErr({ message: 'Fill in the Password field', code: 'Emptypassword.value' });
            }
            if (!email.value && !password.value) {
                setErr({ message: 'Fill in all the fields', code: 'EmptyFields' });
            }
        }
    }
    if (auth.currentUser) { return (<Navigate to="/Profile/dashboard" />) }
    else {
        return (
            <>
                {/* <div style={{width: '320px'}}> */}
                <form onSubmit={logIn} className='logForms'>
                    <img alt='PartyLivePrototype' src='/Logo.png'
                        style={{ width: 300, height: 160, marginTop: 40, marginBottom: 20, alignSelf: 'center',}}
                    />
                    {Err && <div style={{ color: 'red' }}><p style={{ color: 'red' }}>{Err.message}</p></div>}
                    <input className='ProfileInput'
                        type="text"
                        stat={Err && (Err.code === 'EmptyEmail' || Err.code === 'EmptyFields' || Err.code === 'auth/invalid-email') ? 'wrong' : null}
                        placeholder="E-mail"
                        autocompletetype="email"
                        autoCapitalize="none"
                        name='email'
                    />
                    <input className='ProfileInput'
                        stat={Err && (Err.code === 'EmptyPwd' || Err.code === 'EmptyFields' || Err.code === 'auth/wrong-password') ? 'wrong' : null}
                        placeholder="Password"
                        autocompletetype="password"
                        autoCapitalize="none"
                        type="password"
                        name="password"
                    />
                    <button className='btnYorp' style={{ width: '100%' }} type='submit'>
                        <p>Log In</p>
                        <FiLogIn style={{ marginLeft: 15 }} />
                    </button>
                </form>
                <div style={{ display: 'flex', flex: 1, justifyContent: 'center', width: '100%' }}>
                    <div style={{width: '320px'}}>
                        <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                        <nav style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <Link className='RegisterResetButtons'
                                to="/Profile/register"
                            >
                                <p className='ProfileText'>register</p>
                                <FiUserPlus style={{ margin: 5, color: 'var(--ltg)', }} />
                            </Link>
                            <Link className='RegisterResetButtons'
                                to="/Profile/reset_password"
                            >
                                <p className='ProfileText'>Forgot Password</p>
                            </Link>
                        </nav>
                        <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                    </div>
                </div>
                {/* </div> */}
            </>
        )
    };
}
